<!-- Кнопка назад для полноэкранного режима - вне wrapper'а -->
<!-- <button class="control-button back-btn fullscreen-back" (click)="toggleFullscreen()" *ngIf="fullscreenMode" [title]="'tile_map.buttons.exit_fullscreen' | translate">
  <i class="pi pi-chevron-left"></i>
</button> -->

<msf-list-page-wrapper [leftSize]="filtersVisible ? '9' : '12'" [rightSize]="filtersVisible ? '3' : '0'">
  <div left #left>


    <div class="page-header">
      <div class="header-left">
        <app-back-button [title]="'Tile map'" [parentRoute]="'/weather'"></app-back-button>
      </div>
      <div class="header-right">
        <!-- <button class="control-button fullscreen-btn" (click)="toggleFullscreen()" [title]="fullscreenMode ? ('tile_map.buttons.exit_fullscreen' | translate) : ('tile_map.buttons.fullscreen' | translate)">
          <i class="pi pi-window-maximize" *ngIf="!fullscreenMode"></i>
          <i class="pi pi-times" *ngIf="fullscreenMode"></i>
        </button> -->
        <button class="control-button" (click)="toggleFilters()" [title]="filtersVisible ? ('tile_map.buttons.hide_filters' | translate) : ('tile_map.buttons.show_filters' | translate)">
          <i class="pi pi-chevron-right" [class.rotated]="!filtersVisible"></i>
        </button>
      </div>
    </div>


    <div class="region-map-container" [class.dark-theme]="isDarkTheme">

      <!-- Legend - вверху в обычном режиме, внизу в полноэкранном -->
      <msf-tile-map-legend *ngIf="!loading && displayTiles.length > 0" class="legend-top" [items]="getLegendItems()"></msf-tile-map-legend>

      <!-- Лоадер начальной загрузки - показывается только при первой загрузке (когда карта еще не была загружена) -->
      <div *ngIf="loading && !hasLoadedOnce" class="initial-loading-overlay" [class.dark-theme]="isDarkTheme">
        <p-progressSpinner></p-progressSpinner>
      </div>

      <!-- Лоадер поверх карты - показывается когда карта уже была загружена, но идет обновление данных -->
      <div *ngIf="loading && hasLoadedOnce" class="spinner-overlay-map" [class.dark-theme]="isDarkTheme">
        <p-progressSpinner></p-progressSpinner>
      </div>

      <!-- Map Grid -->
      <div class="map-container" #mapContainer [class.hidden]="loading && !hasLoadedOnce">
        <div
          class="map-grid"
          [style.grid-template-columns]="'repeat(' + gridWidth + ', 35px)'"
          [style.grid-template-rows]="'repeat(' + gridHeight + ', 35px)'"
          [style.transform]="'scale(' + gridScale + ')'"
        >
          <div
            *ngFor="let tile of displayTiles"
            [class]="getTileClasses(tile)"
            [class.blue]="tile.color === 'blue'"
            [style.grid-column]="(tile?.mozaikX || 0) + 1"
            [style.grid-row]="(tile?.mozaikY || 0) + 1"
            [attr.data-tooltip]="tile.tooltip"
            (click)="showWeatherInfos(tile)"
          >
            <span class="tile-name">{{ tile.regionData | serverTranslate:'shortNames' }}
            </span>
            <p-progressSpinner
              *ngIf="this.loadingRegion"
              [style]="{ width: '20px', height: '20px' }"
              [strokeWidth]="'2'" styleClass="custom-spinner"/>
          </div>
        </div>
      </div>


      <!-- Заголовок в полноэкранном режиме -->
      <!-- <div *ngIf="!loading && fullscreenMode" class="fullscreen-header">
        <h2 class="fullscreen-title">{{ getFullscreenTitle() }}</h2>
      </div> -->

      <!-- Legend внизу для полноэкранного режима -->
      <!-- <msf-tile-map-legend *ngIf="!loading && fullscreenMode" class="legend-bottom" [items]="getLegendItems()"></msf-tile-map-legend> -->

    </div>
  </div>
  <div right #right>
    <div class="filters-panel">
      <div class="filters-header">
        <h2>{{ getFiltersTitle() }}</h2>
      </div>

      <div class="filters-content">
        <!-- Источник данных (ERA5 | IBM) — выше региона -->
        <div class="filter-section">
          <label>{{ 'tile_map.filters.data_source' | translate }}</label>
          <div class="filter-control">
            <app-dropdown
              [(ngModel)]="filterModel.dataSource"
              [options]="dataSourceOptions"
              [placeholder]="'tile_map.filters.select_data_source' | translate"
              (onChange)="onFilterModelChange()"
            ></app-dropdown>
          </div>
        </div>

        <!-- Регион -->
        <div class="filter-section">
          <label>{{ 'Region' | translate }}</label>
          <div class="filter-control">
            <msf-tree-select
              [(model)]="selectedRegionId"
              [service]="regionManagementManager"
              serviceMethod="getRegionsObservable"
              [placeholder]="'Select Region' | translate"
              appendTo="body"
              [showClear]="true"
              [treeBy]="'parentId'"
              (modelChange)="onFilterModelChange()"
            />
          </div>
        </div>

        <!-- Тип данных -->
        <div class="filter-section">
          <label>{{ 'tile_map.filters.data_type' | translate }}</label>
          <div class="filter-control">
            <app-dropdown
              [(ngModel)]="filterModel.DataType"
              [options]="dataTypeDropdownOptions"
              [placeholder]="'tile_map.filters.select_data_type' | translate"
              (onChange)="onFilterModelChange()"
            ></app-dropdown>
          </div>
        </div>

        <!-- Дата -->
        <div class="filter-section">
          <label>{{ 'Date' | translate }}</label>
          <app-date-picker
            [(ngModel)]="filterModel.date"
            [placeholder]="'Select Date' | translate"
            [showIcon]="true"
            [showClear]="false"
            [dateFormat]="'dd.mm.yy'"
            [dateOnly]="true"
            (ngModelChange)="onFilterModelChange()"
          ></app-date-picker>
        </div>

        <!-- Культура: показываем только для типа данных 5 -->
        <div class="filter-section" *ngIf="filterModel.DataType === 5">
          <label>{{ 'tile_map.filters.culture' | translate }}</label>
          <div class="filter-control">
            <app-dropdown
              [(ngModel)]="filterModel.cropId"
              [options]="cropOptions"
              [placeholder]="'tile_map.filters.select_culture' | translate"
            ></app-dropdown>
          </div>
        </div>

        <!-- Кнопки применения/очистки фильтров -->
        <div class="filter-actions">
          <app-button
            [fullWidth]="true"
            (onClick)="onApplyFilters()"
          >
            {{ 'APPLY' | translate }}
          </app-button>
          <app-button
            variant="secondary"
            [fullWidth]="true"
            (onClick)="onClearFilters()"
          >
            {{ 'Clear' | translate }}
          </app-button>
        </div>
      </div>
    </div>
  </div>
</msf-list-page-wrapper>

<!-- Weather Details Modal -->

@if (showTileWeatherInfos){
  <app-point-polygon-details-modal
    [(visible)]="showTileWeatherInfos"
    [latitude]="selectedTile?.lat"
    [longitude]="selectedTile?.lng"
    [regionPathString]="selectedTileRegionPath"
    [isOnlyInfo]="true"
  ></app-point-polygon-details-modal>
}
